/* FAST TUNING CAR — STEP 9 V8 — DESKTOP NAVIGATION
   Chromium/Arena-safe initialization:
   - Header desktop is injected from #header-desktop-template by common.js
   - We initialize only after desktop-lazyloaded OR when DOM is already present
   - Re-init is idempotent and survives responsive header reinjection
*/
(function(){
  'use strict';

  var globalBound = false;
  var stickyBound = false;
  var stickyNav = null;
  var stickyTop = 0;

  function qsa(root, sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function closeAll(nav, except){
    qsa(nav, '[data-ftc-nav-item]').forEach(function(item){
      if(item === except) return;
      item.classList.remove('is-open');
      var trigger = item.querySelector(':scope > [data-ftc-nav-trigger]');
      if(trigger) trigger.setAttribute('aria-expanded','false');
    });
  }

  function bindItem(nav, item){
    if(item.dataset.ftcBound === '1') return;
    var trigger = item.querySelector(':scope > [data-ftc-nav-trigger]');
    var panel = item.querySelector(':scope > [data-ftc-nav-panel]');
    if(!trigger || !panel) return;
    item.dataset.ftcBound = '1';

    trigger.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var willOpen = !item.classList.contains('is-open');
      closeAll(nav, item);
      item.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if(willOpen){
        var input = panel.querySelector('[data-ftc-brand-search]');
        if(input) window.setTimeout(function(){ input.focus(); }, 50);
      }
    });

    panel.addEventListener('click', function(e){ e.stopPropagation(); });
  }

  function bindCategories(nav){
    var catItems = qsa(nav, '[data-ftc-category-item]');
    catItems.forEach(function(cat){
      if(cat.dataset.ftcCatBound === '1') return;
      var trigger = cat.querySelector(':scope > [data-ftc-category-trigger]');
      var panel = cat.querySelector(':scope > [data-ftc-category-panel]');
      if(!trigger || !panel) return;
      cat.dataset.ftcCatBound = '1';

      function activate(){
        catItems.forEach(function(other){
          var active = other === cat;
          other.classList.toggle('is-open', active);
          var ot = other.querySelector(':scope > [data-ftc-category-trigger]');
          if(ot) ot.setAttribute('aria-expanded', active ? 'true' : 'false');
        });
      }

      trigger.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        activate();
      });
      trigger.addEventListener('mouseenter', activate);
      trigger.addEventListener('focus', activate);
    });
  }

  function bindBrandSearch(nav){
    var search = nav.querySelector('[data-ftc-brand-search]');
    if(!search || search.dataset.ftcBound === '1') return;
    search.dataset.ftcBound = '1';
    ['click','mousedown','keydown','focus'].forEach(function(evt){
      search.addEventListener(evt, function(e){ e.stopPropagation(); });
    });
    search.addEventListener('input', function(){
      var q = (search.value || '').toLocaleLowerCase().trim();
      qsa(nav, '[data-ftc-brand-name]').forEach(function(a){
        var name = a.getAttribute('data-ftc-brand-name') || '';
        a.hidden = !!q && name.indexOf(q) === -1;
      });
    });
  }

  function bindVehicle(nav){
    qsa(nav, '[data-ftc-vehicle-link]').forEach(function(vehicle){
      if(vehicle.dataset.ftcBound === '1') return;
      vehicle.dataset.ftcBound = '1';
      vehicle.addEventListener('click', function(e){
        var target = document.querySelector('#ftc-vehicle-search') || document.querySelector('.single-banner-filter');
        closeAll(nav, null);
        if(!target) return; /* on another page, allow normal href to homepage anchor */
        e.preventDefault();
        window.setTimeout(function(){
          var top = target.getBoundingClientRect().top + window.pageYOffset - 92;
          window.scrollTo({top: Math.max(0, top), behavior:'smooth'});
        }, 40);
      });
    });
  }

  function setupSticky(nav){
    stickyNav = nav;
    stickyTop = nav.getBoundingClientRect().top + window.pageYOffset;
    if(stickyBound) return;
    stickyBound = true;
    var ticking = false;
    function onScroll(){
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(function(){
        if(stickyNav && document.documentElement.contains(stickyNav)){
          document.body.classList.toggle('ftc-nav-sticky-active', window.pageYOffset > stickyTop + 120);
        } else {
          document.body.classList.remove('ftc-nav-sticky-active');
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', function(){
      if(stickyNav && document.documentElement.contains(stickyNav)){
        stickyTop = stickyNav.getBoundingClientRect().top + window.pageYOffset;
      }
    }, {passive:true});
    onScroll();
  }

  function initNav(nav){
    if(!nav) return;
    qsa(nav, '[data-ftc-nav-item]').forEach(function(item){ bindItem(nav, item); });
    bindCategories(nav);
    bindBrandSearch(nav);
    bindVehicle(nav);
    setupSticky(nav);
  }

  function initAll(){
    qsa(document, '[data-ftc-desktop-nav]').forEach(initNav);
  }

  function bindGlobal(){
    if(globalBound) return;
    globalBound = true;
    document.addEventListener('click', function(e){
      qsa(document, '[data-ftc-desktop-nav]').forEach(function(nav){
        if(!nav.contains(e.target)) closeAll(nav, null);
      });
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') qsa(document, '[data-ftc-desktop-nav]').forEach(function(nav){ closeAll(nav, null); });
    });
  }

  bindGlobal();
  document.addEventListener('desktop-lazyloaded', function(){ window.setTimeout(initAll, 0); });
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ window.setTimeout(initAll, 0); });
  } else {
    window.setTimeout(initAll, 0);
  }

  /* Last-resort observer for theme editor / responsive reinjection. */
  if('MutationObserver' in window){
    var observer = new MutationObserver(function(mutations){
      var needsInit = mutations.some(function(m){
        return Array.prototype.some.call(m.addedNodes || [], function(node){
          return node.nodeType === 1 && (node.matches && node.matches('[data-ftc-desktop-nav], .header-desktop') || node.querySelector && node.querySelector('[data-ftc-desktop-nav]'));
        });
      });
      if(needsInit) window.setTimeout(initAll, 0);
    });
    observer.observe(document.documentElement, {childList:true, subtree:true});
  }
})();
